export const data = [
 {
"id": 1,
"title": "Master Type Script in one Video",
"linkImg": "https://img.youtube.com/vi/66_bET6sI20/0.jpg",
 },
 {
    "id": 2,
    "title": "100 Days of Deep Learning with Campu x",
    "linkImg": "https://img.youtube.com/vi/2dH_qjc9mFg/0.jpg",
     },
     {
        "id": 3,
        "title": "DSA Sheets for Interview Preparation!",
        "linkImg": "https://img.youtube.com/vi/QWGbXU7pi4w/0.jpg",
         },
         {
            "id": 4,
            "title": "Which Coding Language to choose?",
            "linkImg": "https://img.youtube.com/vi/SaBevq83WbM/0.jpg",
             },
             {
                "id": 5,
                "title": "Best FREE Way to get Good at Coding",
                "linkImg": "https://img.youtube.com/vi/HXV3zeQKqGY/0.jpg",
                 },
                 {
                    "id": 6,
                    "title": "How to get good at DataStructure",
                    "linkImg": "https://img.youtube.com/vi/aa2ijyWBBIc/0.jpg",
                     },
                     {
                        "id": 7,
                        "title": "Candidate Road Map Master Codeforces",
                        "linkImg": "https://img.youtube.com/vi/PM8gczl7DVw/0.jpg",
                         },
                        

                     
]